import React from 'react';

import { ArticleHeading5, ArticleHeading4, UIText2 } from '@cian/ui-kit';
import styles from './styles.css';
import { IRequirement } from 'shared/types/common/offer';
import { useIsDesktop } from '../../../../hooks/common';

export interface IRequirementsProps {
  requirements: IRequirement[];
}

export const Requirements: React.FC<IRequirementsProps> = props => {
  const { requirements } = props;
  const isDesktop = useIsDesktop();

  return (
    <ul className={styles['list']}>
      {requirements.map((el, index) => {
        return (
          <li key={index}>
            {isDesktop ? <ArticleHeading5>{el.title}</ArticleHeading5> : <ArticleHeading4>{el.title}</ArticleHeading4>}
            {el.text ? <UIText2>{el.text}</UIText2> : null}
          </li>
        );
      })}
    </ul>
  );
};
